import React from "react";
import Translate from "./components/Translate";

const App = () => (
  <div>
    <Translate />
  </div>
);

export default App;
